import templateUrl from "emun.order/order-log-detail.htm";
import OrderLogDetailController from "emun.order/order-log-detail.controller";
import open from "webmodals/open";

let OrderLogDetail = options => {
  let modalInstance = open({
    size: options.size || "lg",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderLogDetailController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderLogDetail;
